import { ActivityType } from '../enums/ActivityType'

// Games and the AI debrief get a room per activity and team; every other activity shares the team or sprint room.
const DEDICATED_ROOM_ACTIVITY_TYPES = new Set<string>([
  ActivityType.FIRST_GAME,
  ActivityType.SHORT_GAME,
  ActivityType.LONG_GAME,
  ActivityType.SHORT_REFLECTION
])

// The activities every team of a sprint holds together, in one room for the whole sprint.
const SPRINT_ROOM_ACTIVITY_TYPES = new Set<string>([ActivityType.INTRODUCTION, ActivityType.LONG_REFLECTION])

export const activityUsesDedicatedRoom = (activityType?: string | null): boolean =>
  !!activityType && DEDICATED_ROOM_ACTIVITY_TYPES.has(activityType)

export const activityUsesSprintRoom = (activityType?: string | null): boolean =>
  !!activityType && SPRINT_ROOM_ACTIVITY_TYPES.has(activityType)
